export default "__VITE_ASSET__Wq27n9gF__"